import type { Country } from "../Country.js";
import type { EconomicSubjectVatType } from "../EconomicSubjectVatType.js";
import { isCountryInEuropeanUnion } from "./isCountryInEuropeanUnion.js";
import { shouldApplyReverseCharge } from "./shouldApplyReverseCharge.js";

export function shouldApplyTax(destinationCountry: Country | "outsideEu", vatType: EconomicSubjectVatType): boolean {
	return isCountryInEuropeanUnion(destinationCountry) && !shouldApplyReverseCharge(destinationCountry, vatType);
}
